import React from 'react';
import BusComponent from '../BusComponent';
import PropTypes from 'prop-types';

/**
 * @typedef Props
 * @property {import('../../').LocationAnalysisType} analysisType
 * @property {number[]} values
 * @property {boolean} isDisabled
 *
 * @extends {BusComponent<Props, {}>}
 */
class AddNewCustomAnalysisValue extends BusComponent {
    handleClick = () => {
        const { analysisType, values, onBeforeOpen } = this.props;
        if (onBeforeOpen) onBeforeOpen();
        this.emit('ADD_LOCATION_ANALYSIS_VALUE_POPUP_REQUEST', { analysisType, values });
    };

    render() {
        const { isDisabled } = this.props;
        return (
            <button
                className="radius-selector__btn radius-selector__btn--add-new-value"
                onClick={this.handleClick}
                disabled={isDisabled}
                data-testid="add-custom-radius-button"
            >
                <i className="material-icons">add</i>
            </button>
        );
    }
}

AddNewCustomAnalysisValue.propTypes = {
    values: PropTypes.array.isRequired,
    analysisType: PropTypes.object.isRequired,
};

export default AddNewCustomAnalysisValue;
